import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlify'
})
export class HtmlifyPipe implements PipeTransform {

  constructor() { }

  transform(value: any, args?: any): any {
    if(value){
      let html = value;
      const toBeHtmlified = value.match(/(#|@)[A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ]+/ig);
      const elements = (toBeHtmlified || []);
      elements.forEach(element => {
        const triggeredWith = element.charAt(0);
        if (triggeredWith == "#") {
          html = html.replace("#" + element.substring(1), `<a href="hashtag/' + hashtag.toLowerCase() + '">#' + hashtag + '</a>`);
        } else {
          html = html.replace("@" + element.substring(1), '<a href="' + element.substring(1) + '">@' + element.substring(1) + '</a>');
        }
      });
      return html;
    }

  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_pipe/htmlify.pipe.ts